import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Header from '../Header';

import {
  getRRSSAudience,
  getRRSSAudienceRecent
} from '../../../utils/apiMiniWidget';
import RRSSAudience from '../../views/RRSSAudience/RRSSAudience';
import { Audiencias } from '../../../../assets/images/index';
import { StyledBoxInside, StyledTitleWidget, StyledWrapper } from './style';
import { SearchByDate } from '../../views/SearchByDate';

const defaultTextForNow = 'No existen datos para el día seleccionado.';

class RRSSAudiencePage extends Component {
  constructor(props) {
    super(props);
    this.state = { recent: undefined, now: undefined };
    this.dateSelected = undefined;
  }

  componentDidMount() {
    getRRSSAudience(moment().format('YYYY-MM-DD'))
      .then(RRSSNowData => {
        this.setState({ now: RRSSNowData });
      })
      .catch(error => {
        console.error('Error desde RRSSAudience', error);
      });
    getRRSSAudienceRecent()
      .then(RRSSResumeData => {
        this.setState({ recent: RRSSResumeData });
      })
      .catch(error => {
        console.error('Error desde RRSSAudience', error);
      });
  }

  selectDate = fromDate => () => {
    this.dateSelected = fromDate;
    getRRSSAudience(fromDate)
      .then(RRSSNowData => {
        this.setState({ now: RRSSNowData });
      })
      .catch(error => {
        console.error('Error desde RRSSAudience', error);
      });
  };

  clickTitle = () => {
    this.forceUpdate();
    this.componentDidMount();
  };

  render() {
    const { history } = this.props;
    const { recent, now } = this.state;

    moment.locale('es');
    return (
      <div
        className="pressResume_container"
        style={{ backgroundColor: '#FFF' }}
      >
        <Header history={history} />

        <StyledBoxInside>
          <StyledTitleWidget
            title="Audiencias #SocialMedia"
            type="resumen"
            icon={Audiencias}
            small
            onClick={this.clickTitle}
          />
          <StyledWrapper>
            <SearchByDate
              day={moment().format('DD')}
              month={moment().format('MMMM')}
              weekday={moment().format('dddd')}
              onClick={this.selectDate}
            />
          </StyledWrapper>
          <StyledWrapper>
            <RRSSAudience
              key="1"
              dataList={now}
              defaultTextForNow={defaultTextForNow}
              title={`Audiencias #SocialMedia del 
                      ${moment(this.dateSelected).format('DD-MM-YYYY')}`}
            />
          </StyledWrapper>
          <StyledWrapper>
            {recent && recent.length > 0 && (
              <RRSSAudience
                key="2"
                dataList={recent}
                title="Los más recientes"
              />
            )}
          </StyledWrapper>
        </StyledBoxInside>
      </div>
    );
  }
}

RRSSAudiencePage.propTypes = {
  author: PropTypes.shape({
    user: PropTypes.shape({ name: PropTypes.string }),
    association: PropTypes.shape({ name: PropTypes.string })
  })
};

export default RRSSAudiencePage;
